import { tv } from 'tailwind-variants';

const tailwindVariantProduct = tv({
  slots: {
    productListContainer: [
      'flex',
      'flex-col',
      'md:flex-row',
      'justify-between',
      'gap-components-card-search-result-spacing-large-image-margin-right',
    ],
    productCard: [
      'content-center',
      'px-spacing-padding-large-1',
      'py-components-card-search-result-spacing-large-padding-y',
    ],
    productTitle: [
      'items-center',
      'content-center',
      'w-full',
      'md:w-[45%]',
      'lg:w-[65%]',
      'font-header-large-xSmall',
      'leading-header-large-xSmall',
      'text-header-large-xSmall',
      'text-components-product-card-color-title',
    ],
    productListLabel: [
      'flex',
      'flex-col',
      'md:flex-row',
      'flex-wrap',
      'self-stretch',
      'content-start',
      'md:content-center',
      'gap-spacing-space-between-large-4',
    ],
    productSection: [
      'flex',
      'flex-col',
      'flex-wrap',
      'self-stretch',
      'content-start',
      'md:content-center',
      'gap-spacing-spacing-3',
    ],
    topSection: [
      'flex',
      'flex-col',
      'flex-wrap',
      'self-stretch',
      'content-center',
      'gap-spacing-spacing-3',
    ],
    bottomSection: [
      'flex',
      'flex-col',
      'flex-wrap',
      'self-stretch',
      'gap-spacing-spacing-3',
      'mt-0',
      'md:mt-[24px]',
    ],
    productMainLabel: [
      '[&>a]:!cursor-pointer',
      '[&>a]:underline',
      'text-components-hyperlink-color-dark-default',
      'hover:text-components-hyperlink-color-dark-hover',
      'md:text-bodySans-medium',
      'md:font-bodySans-medium',
      'md:leading-bodySans-medium',
    ],
    productDates: [
      'md:text-bodySans-medium',
      'md:font-bodySans-medium',
      'md:leading-bodySans-medium',
    ],
  },
});
export default tailwindVariantProduct;

export const tailwindVariantPagination = tv({
  slots: {
    base: ['flex'],
    paginationContainer: ['flex', 'flex-col', 'md:pt-spacing-spacing-7', 'pt-spacing-spacing-5'],
    paginationRoot: ['flex', 'justify-between', 'items-start'],
    paginationIcon: [
      'p-0',
      'min-h-auto',
      ['[&>button]:flex'],
      ['[&>button]:p-0'],
      ['[&>button]:min-h-min'],
      'font-bodySans-medium-semibold',
      'pt-components-button-spacing-compressed-default-padding-y',
      'pb-1.5',
      'rounded-themes-spacing-radius-large-button',
      'bg-components-button-color-text-brand-default-bg',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'text-components-button-color-outline-brand-default-text',
    ],
    paginationPageWrapper: [
      'md:flex',
      'flex-row',
      'gap-spacing-spacing-1',
      'hidden',
      '[&_span]:pb-[3px]',
      '[&_span]:text-components-pagination-on-white-text-default',
    ],
    paginationPage: [
      'flex',
      'py-components-button-spacing-compressed-default-padding-y',
      'px-components-button-spacing-compressed-default-padding-x',
      'rounded-themes-spacing-radius-large-button-icon',
      'font-bodySans-medium-semibold',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'text-components-pagination-on-white-text-default',
    ],
    paginationDisplayPage: [
      'flex-row',
      'justify-center',
      'font-bodySans-medium-semibold',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'md:font-bodySans-small',
      'md:text-bodySans-small',
      'md:leading-bodySans-small',
      'text-components-pagination-on-white-text-default',
    ],
    paginationGroup: ['flex-col', 'items-center', 'gap-spacing-spacing-5', 'flex'],
  },
  variants: {
    isMobile: {
      true: {
        paginationDisplayPage: ['md:hidden', 'flex'],
      },
      false: {
        paginationDisplayPage: ['hidden', 'md:flex'],
      },
    },
    currentPage: {
      true: {
        paginationPage: [
          'bg-components-pagination-on-white-bg-active',
          '!text-components-pagination-on-white-text-active',
        ],
      },
      false: {
        paginationPage: [
          'hover:bg-components-pagination-on-white-bg-hover',
          'hover:text-components-pagination-on-white-text-hover',
        ],
      },
    },
  },
});

export const tailwindMain = tv({
  slots: {
    mainContainer: [
      'product-card-listing',
      'px-themes-general-surface-spacing-small-padding-x',
      'py-themes-general-surface-spacing-small-padding-y',
      'md:px-components-product-results-list-with-search-spacing-large-padding-x',
      'md:py-components-product-results-list-with-search-spacing-large-padding-y',
      'relative',
    ],
    loaderWrapper: [
      'flex',
      'items-center',
      'h-screen',
      'opacity-85',
      'fixed',
      'top-0',
      'right-0',
      'left-0',
      'bottom-0',
      'bg-white',
      'z-50',
    ],
    searchLoaderAnimation: [
      'animate-spin',
      'block',
      'h-[80px]',
      'w-[80px]',
      'm-auto',
      'bg-components-omnibox-color-loader-icon-fill-default',
      '[clip-path:path("M73.3333_40.0038C73.3333_58.4115_58.411_73.3338_40.0033_73.3338C21.5957_73.3338_6.67334_58.4115_6.67334_40.0038C6.67334_21.5962_21.5957_6.67383_40.0033_6.67383C58.411_6.67383_73.3333_21.5962_73.3333_40.0038ZM13.3393_40.0038C13.3393_54.73_25.2772_66.6678_40.0033_66.6678C54.7295_66.6678_66.6673_54.73_66.6673_40.0038C66.6673_25.2777_54.7295_13.3398_40.0033_13.3398C25.2772_13.3398_13.3393_25.2777_13.3393_40.0038Z")]',
    ],
  },
});
